import { Layout } from "antd";
import AppImages from "assets/appImages";
import UserInfo from "components/UserInfo";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import HorizontalNav from "../HorizontalNav";
// import CustomScrollbars from "utils/CustomScrollbars";
// import languageData from "../languageData";
import AppConfig from "utils/Config";

const { Header } = Layout;

const InsideHeader = () => {
  // const [searchText, setSearchText] = useState("");
  // const { locale } = useSelector(({ settings }) => settings);
  // const width = useSelector(({ common }) => common.width);
  const { authUser } = useSelector(({ auth }) => auth);

  const stringToColor = (arg) => {
    const str = arg.split(" ").join(""); // Remove spaces from facility_name
    const combinedString = str + authUser?.facility_code; // Combine facility_name and facility_code
    let hash = 0;
    for (let i = 0; i < combinedString.length; i++) {
      hash = combinedString.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let j = 0; j < 3; j++) {
      const value = (hash >> (j * 8)) & 0xff;

      // Reduce the brightness by subtracting a fixed value (e.g., 20) from each RGB component
      const darkValue = Math.max(0, value - 65);

      // Convert the darkened value back to a hexadecimal string
      const darkHex = `00${darkValue.toString(16)}`.substr(-2);

      color += darkHex;
    }
    return color;
  };

  return (
    <div className="gx-header-horizontal gx-header-horizontal-dark gx-inside-header-horizontal">
      <Header className="gx-header-horizontal-main">
        <div className="lg:mx-6 mx-2">
          <div
            className="gx-header-horizontal-main-flex flex justify-between"
            style={{ height: "3.5rem" }}
          >
            <Link
              to="#"
              className="lg:hidden flex gx-pointer gx-mr-xs-3 gx-pt-xs-1 gx-w-logo"
            >
              <img alt="logo" src={AppImages.LogoSm} width={35} />
            </Link>
            <Link
              to="#"
              className="gx-pointer lg:flex hidden items-center gap-2"
            >
              <img alt="logo" src={AppImages.LogoSm} width={40} />
              {AppConfig.appName}
            </Link>

            {/* {width >= IPAD_SIZE && ( */}
            <div className="gx-w-50 gx-header-horizontal-nav gx-header-horizontal-nav-curve">
              <HorizontalNav />
            </div>
            {/* )} */}
            <ul className="gx-header-notifications">
              <li className="gx-user-nav">
                <UserInfo dashboardView stringToColour={stringToColor} />
              </li>
            </ul>
          </div>
        </div>
      </Header>
    </div>
  );
};

export default InsideHeader;
